import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50fc9ed2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid-title-new-button" }
const _hoisted_2 = { class: "header-row" }
const _hoisted_3 = { class: "first-column" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "title icon-column" }, "Confirmed")
], -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title icon-column" }, "Remove", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "first-column" }
const _hoisted_10 = {
  key: 0,
  class: "grid-item"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "blocked"
}
const _hoisted_13 = {
  key: 1,
  class: "grid-item"
}
const _hoisted_14 = { class: "icon-column" }
const _hoisted_15 = { class: "grid-item" }
const _hoisted_16 = {
  key: 0,
  class: "icon-column"
}
const _hoisted_17 = ["onClick"]

import { PropType, computed, ref } from "vue";
import GridMenu from "@/components/ui/grid/grid-menu.vue";
import { ContextMenuItem } from "@/types/ui/menus/ContextMenuItem";
import { DxButton } from "devextreme-vue";
import SwitchToggle from "@/components/ui/toggles/switch-toggle.vue";
import contactsPeekPopup from "@/components/contacts/contacts-peek-popup.vue";
import { AppoinmentProperty } from "@/types/diary/AppointmentProperty";
import { AppoinmentContact } from "@/types/diary/AppoinmentContact";


export default /*#__PURE__*/_defineComponent({
  __name: 'attendee-property-list',
  props: {
  modelValue: {
    type: Array as PropType<AppoinmentContact[] | AppoinmentProperty[]>,
    required: true,
  },
  /**
   * If it is the creation of an appointment, we check blockages on attendees.
   * @type {boolean}
   * @default false
   */
  isAppointmentCreation: {
    type: Boolean,
    default: false,
  },
  /**
   * Determines whether the specific contact is attendee.
   * @type {boolean}
   * @default true
   */
  isAttendee: {
    type: Boolean,
    default: true,
  },
  /**
   * The unique identifier for the attendee List Dropdown.
   * @type {string}
   * @default: 'attendee-types-menu'
   */
  attendeeListDropdownId: {
    type: String,
    default: "attendee-types-menu",
  },
  /**
   * Determines whether the control is read only.
   * @type {boolean}
   * @default false
   */
  readOnly: {
    type: Boolean,
    default: false,
  },
  /**
   * Determines whether add button is read only.
   * @type {boolean}
   * @default false
   */
  disableAdding: {
    type: Boolean,
    default: false,
  },
  /**
   * Will enable the warning when the field is required and has no value
   * @type {boolean}
   * @default false
   */
  enableDisplayWarning: {
    type: Boolean,
    default: true,
  },
  /**
   * The number of entries required for the list to be valid
   * @type {Number}
   * @default false
   */
  requiredAmount: {
    type: Number,
    default: 1,
  },
  /**
   * Allows the validation to be displayed if a list is required.
   * @type {boolean}
   * @default false
   */
  requiredField: {
    type: Boolean,
    default: false,
  },
},
  emits: [
  "deleteGridItem",
  "itemClicked",
  "createNewProperty",
  "update:modelValue",
],
  setup(__props, { emit }) {

const props = __props;



const menuAttendeeTypes = ref<ContextMenuItem[]>([
  { key: "contact", text: "Contact", icon: "fas fa-search" },
  { key: "me", text: "Me", icon: "fas fa-user" },
  { key: "user", text: "User", icon: "fas fa-user-plus" },
]);



const gridItems = computed({
  get: () => props.modelValue,
  set: (value: AppoinmentContact[] | AppoinmentProperty[]) =>
    emit("update:modelValue", value),
});

const showPeek = ref(false);

const peekedContact = ref<AppoinmentContact>({
  contactId: 0,
  name: "",
  confirmed: false,
  blocked: [],
});

const onPeekIconClick = (item: AppoinmentContact) => {
  peekedContact.value = item;
  showPeek.value = true;
};

const tableHeaderClass = computed(() => {
  let tableHeader = "table-header";
  if (
    props.requiredField &&
    gridItems.value.length < props.requiredAmount &&
    props.enableDisplayWarning
  )
    tableHeader += " table-invalid";
  return tableHeader;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", {
        class: _normalizeClass(tableHeaderClass.value)
      }, _toDisplayString(props.isAttendee ? "Attendees" : "Properties"), 3),
      (props.isAttendee)
        ? (_openBlock(), _createBlock(GridMenu, {
            key: 0,
            "menu-items": menuAttendeeTypes.value,
            disabled: props.readOnly || props.disableAdding,
            onItemClicked: _cache[0] || (_cache[0] = (key) => emit('itemClicked', key)),
            "button-icon": "",
            "button-text": "Add",
            id: __props.attendeeListDropdownId
          }, null, 8, ["menu-items", "disabled", "id"]))
        : (_openBlock(), _createBlock(_unref(DxButton), {
            key: 1,
            text: "Add",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('createNewProperty'))),
            disabled: props.readOnly || props.disableAdding
          }, null, 8, ["disabled"]))
    ]),
    _createElementVNode("table", null, [
      _createElementVNode("tr", _hoisted_2, [
        _createElementVNode("th", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(props.isAttendee ? "Name" : "Address"), 1)
        ]),
        _hoisted_5,
        (!props.readOnly)
          ? (_openBlock(), _createElementBlock("th", _hoisted_6, _hoisted_8))
          : _createCommentVNode("", true)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gridItems.value, (item, index) => {
        return (_openBlock(), _createElementBlock("tr", {
          class: "content-row",
          key: index
        }, [
          _createElementVNode("td", _hoisted_9, [
            (props.isAttendee)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                  _createElementVNode("i", {
                    class: "fas fa-user peek-icon",
                    onClick: ($event: any) => (onPeekIconClick(item))
                  }, null, 8, _hoisted_11),
                  _createTextVNode(" " + _toDisplayString(item.name) + " ", 1),
                  (props.isAppointmentCreation && item.blocked.length > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(item.address), 1))
          ]),
          _createElementVNode("td", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(SwitchToggle, {
                modelValue: item.confirmed,
                "onUpdate:modelValue": ($event: any) => ((item.confirmed) = $event),
                readOnly: 
              props.readOnly ||
              (props.isAppointmentCreation &&
                props.isAttendee &&
                item.blocked.length > 0)
            ,
                marginBottom: "0rem"
              }, null, 8, ["modelValue", "onUpdate:modelValue", "readOnly"])
            ])
          ]),
          (!props.readOnly)
            ? (_openBlock(), _createElementBlock("td", _hoisted_16, [
                _createElementVNode("i", {
                  class: "fa-solid fa-trash delete-icon grid-item",
                  onClick: ($event: any) => (
            emit(
              'deleteGridItem',
              props.isAttendee ? item.contactId : item.propertyId,
            )
          )
                }, null, 8, _hoisted_17)
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    _createVNode(contactsPeekPopup, {
      modelValue: showPeek.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showPeek).value = $event)),
      contactId: peekedContact.value.contactId,
      title: peekedContact.value.name
    }, null, 8, ["modelValue", "contactId", "title"])
  ], 64))
}
}

})